import { notificationSchema } from "@features/vessel-call/vessel-call-status/PortServices/flow/utils";
import i18n from "i18next";
import { z } from "zod";

const LANG_BASE = "vessel-call.port-services.fields";

const createSpecialInstructionsSchema = () =>
  z.object({
    specialInstructions: z
      .string()
      .min(
        1,
        i18n.t("form-validation.required", {
          label: i18n.t(`${LANG_BASE}.special-instructions`),
        }),
      )
      .max(
        1500,
        i18n.t("form-validation.max-length", {
          label: i18n.t(`${LANG_BASE}.special-instructions`),
          required_error: i18n.t("form-validation.required", {
            label: i18n.t(`${LANG_BASE}.special-instructions`),
          }),
          max: 1500,
        }),
      ),
    attachment: z.any().optional(),
    notes: z
      .string()
      .max(
        1000,
        i18n.t("form-validation.max-length", {
          label: i18n.t(`${LANG_BASE}.notes`),
          max: 1000,
        }),
      )
      .optional(),
  });

export const approveByHSESlopsDisposalSchema = () =>
  createSpecialInstructionsSchema().merge(notificationSchema);

export type ApproveByHSESlopsDisposalSchema = z.infer<
  ReturnType<typeof approveByHSESlopsDisposalSchema>
>;
